import React, {FunctionComponent, useState, useContext, useMemo} from "react";
import {ChallengeRatingData} from "/src/domain/challenges/ChallengeRatingData";
import {RatingContext, RatingContextProps} from "/src/contexts/RatingContext";
import RatingTrainers from "/src/ui/challengeRating/ratingTrainers/RatingTrainers";
import RatingParticipants from "/src/ui/challengeRating/ratingParticipants/RatingParticipants";
import {Tabs, Tab, LinearProgress} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import {useTranslation} from "react-i18next";
import {isObject, isString} from "lodash";
import RatingClubs from "/src/ui/challengeRating/ratingClubs/RatingClubs";

interface RatingDada {
    challengeRating: ChallengeRatingData;
    currentUserId?: string;
}

const Ratings: FunctionComponent<RatingDada> = ({
                                                    challengeRating,
                                                    currentUserId
                                                }) => {
    const {t} = useTranslation()
    const classes = useStyles()

    const [currentSeasonId, setCurrentSeasonId] = useState(challengeRating.currentSeasonId)

    const {ratingSeasonData, requestRatingSeasonData, seasonProgress} = useContext(RatingContext) as RatingContextProps

    const seasons = useMemo(() => challengeRating.seasons.reverse(), [challengeRating])

    const changeCurrentSeasonId = (event: React.ChangeEvent<{}>, newValue: number) => {
        setCurrentSeasonId(newValue);
        requestRatingSeasonData(newValue)
    }

    const rating = isObject(ratingSeasonData) ? ratingSeasonData : challengeRating

    return (
        <div>
            <div className={classes.linearProgress}>
                {seasonProgress && <LinearProgress color="secondary"/>}
            </div>
            <Tabs
                textColor="secondary"
                value={currentSeasonId}
                indicatorColor="secondary"
                scrollButtons="auto"
                variant="scrollable"
                onChange={changeCurrentSeasonId}
            >
                {
                    seasons.map((season) => (
                        <Tab value={season.id} key={season.id} label={season.name}/>
                    ))
                }
            </Tabs>
            {
                isString(ratingSeasonData) ?
                    <div className={classes.errorMessage}>
                        {t(ratingSeasonData as string)}
                    </div>
                    : (<>
                        <RatingClubs ratingClubs={rating.clubs}
                                     currentSeasonId={currentSeasonId}
                                     currentUserId={currentUserId}/>
                        <RatingTrainers
                            ratingTrainers={rating.ratingTrainers}
                            currentUserId={currentUserId}
                        />
                        <RatingParticipants
                            currentSeasonId={currentSeasonId}
                            ratingParticipants={rating.ratingParticipants}
                            currentUserId={currentUserId}
                        />
                    </>)
            }

        </div>
    )
}

const useStyles = makeStyles(muiTheme => ({
    linearProgress: {
        height: '0.5rem'
    },
    errorMessage: {
        margin: '1.5rem',
        color: muiTheme.palette.primary.main,
        fontWeight: 500
    }
}))

export default Ratings